import { type Client, createInstance, type OptimizelyUserContext } from '@optimizely/optimizely-sdk';
import Cookie from 'js-cookie';
import { create } from 'zustand';

import { getENV } from '../utils';

type InitProps = {
    pathname: string;
    deviceType: 'mobile' | 'tablet' | 'desktop';
    team?: string;
};

interface OptimizelyStore {
    init: (props: InitProps) => void;
    instance: Client | null;
    context: OptimizelyUserContext | null;
}

export const useOptimizely = create<OptimizelyStore>((set, get) => ({
    context: null,
    instance: null,
    init({ pathname, deviceType, team = '*' }) {
        const context = get().context;
        if (context) return context.setAttribute('Pathname', pathname);

        const instance = createInstance({
            logLevel: 4,
            sdkKey: getENV('NEXT_PUBLIC_OPTIMIZELY_SDK_KEY'),
        });

        instance?.onReady().then(() => {
            set(() => ({
                instance,
                context: instance.createUserContext(Cookie.get('x-petm-visitor-id'), {
                    Domain: window.location.host,
                    App: getENV('NEXT_PUBLIC_APP_NAME') === 'cpc' ? 'cart' : getENV('NEXT_PUBLIC_APP_NAME'),
                    Pathname: pathname,
                    Devicetype: deviceType,
                    Team: team,
                    $opt_user_agent: navigator.userAgent,
                }),
            }));
        });
    },
}));
